import React from 'react';
import { Text } from '@atlaskit/primitives/compiled';
import { useIntl, defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	hasErrorIndicator: {
		id: 'accessible-workflow-diagram.common.validation-indicator.has-error-indicator',
		defaultMessage: 'Has error.',
		description: 'Indicates that a status or transition has an error',
	},

	hasWarningIndicator: {
		id: 'accessible-workflow-diagram.common.validation-indicator.has-warning-indicator',
		defaultMessage: 'Has warning.',
		description: 'Indicates that a status or transition has a warning',
	},
});

const ValidationIndicator = ({ validationFlag }: { validationFlag?: 'error' | 'warn' }) => {
	const { formatMessage } = useIntl();
	if (!validationFlag) return null;

	return (
		<Text>
			{formatMessage(
				validationFlag === 'error' ? messages.hasErrorIndicator : messages.hasWarningIndicator,
			)}
		</Text>
	);
};

export default ValidationIndicator;
